export const state = {
  goodsreceiving: [],
  goods_order_items: [
    {
      product_id: "",
      product_measurement: "",
      qty: "",
      unit_price: "",
      sell_price: "",
      total_price: "",
      supplier_id: ""
    }
  ],
  good_receiving_items: [],
  systemGoodreceiving: [],
  systemGoodreceivings: [],
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/goodsreceiving/state.js